module.exports = __webpack_public_path__ + "static/media/Russian_Yuri BG-34.1b68f404.png";